import { Component, Inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';

import { NgxSpinnerService } from 'ngx-spinner';
import { Arende } from '../../interfaces/arende.interface';
import { AllaArendenService } from './alla-arenden.service';
import { SessionService } from '../../session/session.service';
import { fadeInAnimation } from '../../_animations/fade-in.animation';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedStateProvider } from '../../sharedStateProvider/shared-state-provider';

@Component({
    selector: 'app-alla-arenden',
    templateUrl: './alla-arenden.component.html',
    styleUrls: ['./alla-arenden.component.scss'],
    animations: [
        fadeInAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AllaArendenComponent {
  constructor(
    protected service: AllaArendenService,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router,
    @Inject(DOCUMENT) private readonly document: Document) {
  }

  public get isLoaded() { return !!this.allaArenden };

  public ngOnInit() {
    this.loadAllaArenden();
  }

  public ngOnDestroy(): void {
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public scrollToArende(): void {
    function offset(el): number {
      const rect = el.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return rect.top + scrollTop;
    }

    this.route.queryParamMap.subscribe(paramMap => {
      this.previousArendeId = paramMap.get('previous');
      const targetElement = this.document.querySelector(`tr[id='${this.previousArendeId}']`);
      if (this.previousArendeId && targetElement) {
        const top = offset(targetElement) - (window.innerHeight / 2);
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      }
    });
  }

  public userFilter: any;

  public applyFilter() {
    this.userFilter = {
      $or: [
        {
          galdenar: {
            $or: [
              { namn: this.filterText },
              { orgnr: this.filterText }
            ]
          }
        },
        { huvudHandlaggare_cache: this.filterText }
      ]
    }
  }

  public filterText: string;
  public order: string = 'galdenar.namn';
  public reverse: boolean = false;
  public previousArendeId: string;

  public subscription: Subscription;

  public allaArenden: Arende[];

  private loadAllaArenden() {

    const callback = () => {
      setTimeout(() => {
        if (!this.allaArenden) {
          this.spinner.show();
        }
      },
        300);

      this.sessionService.getInstances().subscribe(() => {
        this.service.getAllaArenden(this.sessionService.activeInstance.id).subscribe(
          result => {
            this.spinner.hide();
            this.allaArenden = result;
          });
      });
    };

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    if (!this.sessionService.hasActiveInstance) {
      this.sessionService.selectInstance(callback);
      return;
    }

    callback();
  }

  public get instanceName() {
    const instance = this.sessionService.activeInstance;
    return instance ? instance.name : '';
  }

  public setOrder(order: string) {
    if (this.order === order) {
      this.reverse = !this.reverse;
    }

    this.order = order;
  }
}
